import { makeStyles } from '@material-ui/core'
import { COLORS } from '@styles'

const useStyles = makeStyles({
  main: {
    marginTop: 0,
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    paddingTop: 30,
  },
  logo: {
    marginBottom: 40,
  },
  verifiedAccount: {
    marginBottom: 40,
  },
  contentWrapper: {
    width: '100%',
    maxWidth: 620,
    margin: '20px auto',
    padding: 26,
    borderRadius: 35,
    boxShadow: '5px 5px 50px 0 rgba(0, 0, 0, 0.16)',
    '& a': {
      textDecoration: 'none',
      color: '#333',
    },
  },
  submitAlert: {
    textAlign: 'center',
    margin: 20,
  },
  button: {
    width: 200,
    margin: '20px auto',
    display: 'block',
  },
  link: {
    alignItems: 'center',
    textDecoration: 'underline !important',
    color: `${COLORS.RED} !important`,
    fontSize: '12px',
    fontStretch: 'normal',
    fontWeight: 'bold',
  },
})

export { useStyles }
